import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./tooltip.html";
import { PopoverHorizontalOrientation, PopoverVerticalOrientation } from 'ace/popover';
import { selectSharedLabels, WireI18n } from '~/modules/stores/i18nStore';
class Tooltip extends LightningElement {
  constructor(...args) {
    super(...args);
    // @ts-expect-error * Automated Type Error Fix
    this.tooltipData = null;
    // @ts-expect-error * Automated Type Error Fix
    this.popoverLayout = void 0;
    // @ts-expect-error * Automated Type Error Fix
    this.popoverOrientation = void 0;
    this.defaultOrientation = {
      vertical: PopoverVerticalOrientation.BOTTOM,
      horizontal: PopoverHorizontalOrientation.RIGHT
    };
    this.showPopover = false;
    this.ariaExpanded = 'false';
    this.labels = void 0;
  }
  get orientation() {
    return this.popoverOrientation || this.defaultOrientation;
  }
  get handleTooltipButtonRef() {
    return this.template.querySelector('.tooltip-button');
  }
  get ariaMoreInfo() {
    return this.labels.moreInfo;
  }
  get isTextTooltip() {
    return typeof this.tooltipData === 'string';
  }
  get popoverLayoutStyle() {
    return `table-container ${this.popoverLayout}`;
  }
  handleTooltipButtonFocus() {
    this.handleTooltipButtonRef?.focus();
  }
  togglePopover() {
    if (this.showPopover === false) {
      this.openPopover();
    } else {
      this.closePopover();
    }
  }
  openPopover() {
    this.showPopover = true;
    this.ariaExpanded = 'true';
  }
  closePopover() {
    this.showPopover = false;
    this.ariaExpanded = 'false';
    this.handleTooltipButtonFocus();
  }

  // @ts-expect-error * Automated Type Error Fix
  handleInputKey(event) {
    if (event.key === 'Escape') {
      this.closePopover();
      event.preventDefault();
      event.stopPropagation();
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Tooltip, {
  publicProps: {
    tooltipData: {
      config: 0
    },
    popoverLayout: {
      config: 0
    },
    popoverOrientation: {
      config: 0
    }
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectSharedLabels
        };
      }
    }
  },
  fields: ["defaultOrientation", "showPopover", "ariaExpanded"]
});
const __lwc_component_class_internal = _registerComponent(Tooltip, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;